package com.anjuros.website.pages.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.sections.blogarticle.BlogArticlePage
import com.anjuros.website.templates.selection.modules.BlogCard
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun TenWaysSoleTraderCanGetMoreCustomers() {
    BlogArticlePage(BlogCard.BLOG2)
}
